import './inputfield.less'

import {m} from '@codeurs/front'
import {BriefcaseIcon, EnvelopeIcon, UserIcon} from 'assets/inline-icons'
import {ErrorMessage} from 'formik'
import React, {FunctionComponent} from 'react'
import {style} from 'util/style'

const styles = style('inputfield')

export const InputField: FunctionComponent<{
  name: string
  icon: 'briefcase' | 'envelope' | 'user'
}> = ({name, icon, children, ...props}) => (
  <div class={styles()}>
    <div class={styles('field').mergeProps(props)}>
      <InputFieldIcon icon={icon} />
      {children}
    </div>
    <ErrorMessage name={name}>
      {msg => <div class={styles('error')}>{msg}</div>}
    </ErrorMessage>
  </div>
)

const InputFieldIcon = ({icon, ...props}) => {
  switch (icon) {
    case 'briefcase':
      return <BriefcaseIcon {...props} />
    case 'envelope':
      return <EnvelopeIcon {...props} />
    case 'user':
      return <UserIcon {...props} />
    default:
      return null
  }
}
